<template>
	<div class="refund-edit">
		<b-card-group deck>
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<span class="hide-print">
						<h5>Продажа <strong> №:{{ item.saleNumber}}</strong></h5>
					</span>
					<b-button variant="outline" @click.prevent="closeSidebar" class="hide-print">
						<i class="fa fa-close"></i>
					</b-button>
				</div>
				<div class="box box-solid">
					<div class="box-header">
						<h3 class="box-title">{{ item.shopName }}</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-sm-4">
								<strong>№ продажи .:</strong> {{ item.saleNumber}} <br>
								<strong>Дата:</strong> {{ item.saleDate}}
							</div>
							<div class="col-sm-4">
								<strong>Кассир:</strong> {{ item.cashierFullName}} <br>
<!--								<strong>Location:</strong> Paradise-->
							</div>
						</div>
					</div>
				</div>
				<hr>
				<b-table class="generalTableClass"
						 striped="striped"
						 bordered="bordered"
						 small="small"
						 fixed="fixed"
						 :items="item.saleItems"
						 responsive="sm"
						 :fields="computedFields"
				>
					<template slot="id" slot-scope="data">
						{{ data.index + 1 }}
					</template>
					<template slot="removeCount" slot-scope="data">
						<input type="number" name="removeCount" @focusout.prevent="setData(data.item,$event)" value="0" @click="$event.target.select()"
							   @focus="$event.target.select()" class="form-control input-sm input_number return_qty input_quantity valid"
							   aria-invalid="false"
							   autocomplete="off"
						>
					</template>
				</b-table>
				<div>
<!--					<b-modal v-model="modalShow" hide-footer hide-header centered>-->

<!--						<div class="d-block text-center">-->
<!--							<h3>Are you sure?</h3>-->
<!--							<br>-->
<!--						</div>-->
<!--						<div>-->
<!--							<b-button variant="outline-danger" size="sm" block-->
<!--									  @click.prevent="modalShow = !modalShow">-->
<!--								{{$t('actions.no')}}-->
<!--							</b-button>-->
<!--							<b-button variant="outline-success" size="sm" block @click="success">-->
<!--								{{$t('actions.yes')}}-->
<!--							</b-button>-->
<!--						</div>-->

<!--					</b-modal>-->

					<b-modal
						v-model="modalShow"
						@ok="success"
						@cancel="modalShow = !modalShow"
						ok-title="Да"
						cancel-title="Отмена"
					>
							<h4>Вы уверены?</h4>
					</b-modal>
				</div>
				<div class="row">
					<div class="col-sm-12 text-right">
						<strong>Сумма возврата: </strong>&nbsp;
						<span id="net_return">{{ totalDiscount }} {{ userDepCurrencyName }}</span>
					</div>
				</div>
			</b-card>
		</b-card-group>


		<div class="row top mt-3 justify-content-end">
			<div class="col-2">
				<b-button variant="outline-danger" size="sm" block
						  @click.prevent="closeSidebar">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-2">
				<b-button variant="outline-success" size="sm" block @click="modalShow = !modalShow">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default{
		name: 'SaleEdit',
		props:['item'],
		data(){
			return{
				items:[],
				getId: null,
				removeCount: [],
				count: 0,
				total: 0,
				modalShow: false,
				totalDiscount: 0,
				returnItems: [],
				search: {
					page: 1,
					limit: 20,
					attributes: []
				},
				events:[]
			}
		},
		methods:{
			closeSidebar(){
				this.$emit('closeSidebar')
			},
			success(){
				this.modalShow = false
				let obj = Object.assign({}, this.item)
				obj.saleItems = this.returnItems
				this.totalDiscount = 0
				this.returnItems =[]

				// Set all events default value to 0
				this.events.forEach(event => {
					event.target.value = 0
				})
				this.$emit('updateSaleRefound',obj)
			},
			setData(data, $event){
				this.events.push($event)
				let obj = Object.assign({}, data)
				if($event.target.value > obj.count)
					$event.target.value = obj.count
				var index = this.returnItems.findIndex((x => x.id === obj.id));

				if (index === -1){
					obj.count = $event.target.value
					this.returnItems.push(obj)
				}else{
					this.returnItems[index].count = $event.target.value
				}

				this.totalDiscount = 0
				this.returnItems.forEach( each => {
					this.totalDiscount += (each.count !== '' ? parseInt(each.count) : 0 ) * parseInt(each.priceUzs)
				})

			}
		},

		computed: {
            ...mapState(['userDepCurrencyName']),
			computedFields() {
				return [
					{
						key: 'id',
						label: '№',
						sortable: true
					},
					{
						key: 'shortName',
						label: 'Название',
						sortable: true
					},
					{
						key: 'barcode',
						label: 'Штрихкод',
						sortable: true
					},
					{
						key: 'count',
						label: 'Кол-во. Общая',
						sortable: true
					},
					{
						key: 'removeCount',
						label: 'Кол-во. Возврат',
					},
					{
						key: 'priceUzs',
						label: this.userDepCurrencyName,
						sortable: true
					},
				]
			},
		},
		mounted() {
		}

	}
</script>
<style scoped>
	.top-card{
		display: flex;
		justify-content: space-between;
		align-item: center;
	}
</style>
